import { render, staticRenderFns } from "./tagList.vue?vue&type=template&id=5234f432&"
import script from "./tagList.vue?vue&type=script&lang=js&"
export * from "./tagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports